import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ThumbUpIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M21.796 7.635a2.06 2.06 0 0 0-1.546-.697h-5.438V5.25a3.563 3.563 0 0 0-3.562-3.562.56.56 0 0 0-.503.311L7.152 9.188H3A1.313 1.313 0 0 0 1.688 10.5v8.25A1.313 1.313 0 0 0 3 20.063h16.125a2.063 2.063 0 0 0 2.047-1.807l1.125-9a2.06 2.06 0 0 0-.501-1.621M2.813 18.75V10.5a.19.19 0 0 1 .188-.188h3.938v8.625H3a.19.19 0 0 1-.188-.188m18.367-9.634-1.125 9a.94.94 0 0 1-.93.821H8.063V9.884l3.524-7.048a2.44 2.44 0 0 1 2.101 2.414V7.5a.563.563 0 0 0 .563.563h6a.938.938 0 0 1 .93 1.054"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
